import { useContext, useEffect, useState } from "react";
import styles from "./EndScreen.module.scss";
import Fireworks from "react-canvas-confetti/dist/presets/fireworks";
import Lottie from "lottie-react";
import animationData from "../../../../public/images/animations/receipt-animation.json";
import useJoyStickNavigation, {
  joystickEvent,
} from "hooks/UseJoyStickNavigation";
import { useNavigate } from "@tanstack/react-router";
import Fade from "components/UI/Animations/Fade/Fade";
import { UserInfoContext } from "context/UserInfoContext";
import useGetReceiptData from "actions/quiz/useGetReceiptData";
import { ReceiptEntity } from "typings/Database/Receipt";

export default function EndScreen() {
  const [buttonAnimation, setButtonAnimation] = useState(false);
  const [receiptAnimation, setReceiptAnimation] = useState(false);
  const [navigateToScreenSaver, setNavigateToScreenSaver] = useState(false);
  const { userInfo } = useContext(UserInfoContext);
  // const [receiptData, setReceiptData] = useState(null);
  const [big] = useState(new Audio("/audio/prizes/big.mp3"));
  const [medium] = useState(new Audio("/audio/prizes/medium.mp3"));
  const [small] = useState(new Audio("/audio/prizes/small.mp3"));

  const { data: receiptData } = useGetReceiptData(userInfo?.id);

  useEffect(() => {
    const interval = setInterval(() => {
      setButtonAnimation((prevState) => !prevState);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    if (navigateToScreenSaver) {
      navigate({ to: "/data-screen-saver" });
    }
  }, [navigateToScreenSaver]);

  const handleJoyStick = (event: joystickEvent) => {
    if (event === "enter") {
      if ((receiptData as ReceiptEntity[])[0]?.prize === "big") {
        big.play();
      }
      if ((receiptData as ReceiptEntity[])[0]?.prize === "medium") {
        medium.play();
      }
      if ((receiptData as ReceiptEntity[])[0]?.prize === "small") {
        small.play();
      }
      console.log(receiptData);
      //writeMessage(JSON.stringify(receiptData));
      setReceiptAnimation(true);
    }
  };

  const { writeMessage } = useJoyStickNavigation(handleJoyStick);

  return (
    <Fade>
      {receiptAnimation ? (
        <Lottie
          style={{ width: "1280px", height: "1024px" }}
          animationData={animationData}
          loop={false}
          onComplete={() => setNavigateToScreenSaver(true)}
        />
      ) : (
        <div className={styles.wrapper}>
          <Fireworks autorun={{ speed: 2, duration: 2500 }} />
          <h1>Bedankt voor het mee doen!</h1>
          <p>
            Benieuwd naar jouw resultaten? Print de bon door op de knop te
            duwen.
          </p>
          <div className={styles.buttonAnimationWrapper}>
            {!buttonAnimation ? (
              <img src="/images/icons/button-up.svg" />
            ) : (
              <img src="/images/icons/button-down.svg" />
            )}
          </div>
        </div>
      )}
    </Fade>
  );
}
